import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Web.Services.Filter {
  export interface IQuery {
    checkedFilters: IFilter[];
    sorter?: ISorter;
    page: number;
    applyFilterGroupCount?: IFacetGroupCount;
    searchString: string;
    pageSize: number;
    discountId?: string;
  }

  export interface IFacetGroupCount {
    key: string;
    valueCountData: IFacetValueCount[];
  }

  export interface IFacetValueCount {
    value: string;
    count: Number;
  }

  export interface IFilter {
    key: string;
    operator: FilterOperator;
    values: string[];
  }

  export enum FilterOperator {
    Equal,
    NotEqual,
    GreaterThan,
    LessThan
  }

  export interface ISorter {
    key: string;
    sortdirection: number;
  }

  export const GetProducts = async (
    pageId: string,
    data: IQuery,
    filterFor: string,
    productListName,
    discountId: string = null
  ): Promise<any> => {
    const encodedPageId = encodeURIComponent(pageId);
    const encodedFilterFor = encodeURIComponent(filterFor);
    const encodedProductListName = encodeURIComponent(productListName);
    const url = `/category?handler=ProductList&pageId=${encodedPageId}&filterFor=${encodedFilterFor}&productListName=${encodedProductListName}&discountId=${discountId}`;
    return easyfyAxios.post(
      url,
      data
    );
  };

  export const GetArticles = async (
    pageId: string,
    data: IQuery
  ): Promise<any> => {
    const encodedPageId = encodeURIComponent(pageId);
    const url = `/articlelist?handler=ArticleList&pageId=${encodedPageId}`;
    return easyfyAxios.post(
      url,
      data
    );
  };
}

export default Easyfy.Web.Services.Filter;
